__turbopack_context__.v({
  "content": "SearchBar-module-scss-module__qnQoNq__content",
  "placeholder": "SearchBar-module-scss-module__qnQoNq__placeholder",
  "placeholder-text": "SearchBar-module-scss-module__qnQoNq__placeholder-text",
  "search-bar": "SearchBar-module-scss-module__qnQoNq__search-bar",
  "search-input-wrapper": "SearchBar-module-scss-module__qnQoNq__search-input-wrapper",
  "search-item": "SearchBar-module-scss-module__qnQoNq__search-item",
  "search-item-wrapper": "SearchBar-module-scss-module__qnQoNq__search-item-wrapper",
  "search-list": "SearchBar-module-scss-module__qnQoNq__search-list",
  "selected": "SearchBar-module-scss-module__qnQoNq__selected",
  "tag-container": "SearchBar-module-scss-module__qnQoNq__tag-container",
  "thumbnail": "SearchBar-module-scss-module__qnQoNq__thumbnail",
});
